var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 31,
    viewBox: "0 0 44 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_1325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0243 4.83514C42.7719 3.90058 42.2797 3.04858 41.5966 2.36397C40.9136 1.67936 40.0635 1.18603 39.131 0.9331C35.7172 0 21.9778 0 21.9778 0C21.9778 0 8.2377 0.0282444 4.82389 0.961344C3.8914 1.21429 3.04128 1.70764 2.35822 2.39229C1.67515 3.07693 1.18295 3.92897 0.930653 4.86356C-0.101942 10.9427 -0.502505 20.2058 0.959007 26.0417C1.21133 26.9763 1.70354 27.8283 2.38661 28.5129C3.06967 29.1975 3.91977 29.6908 4.85225 29.9438C8.26605 30.8769 22.0058 30.8769 22.0058 30.8769C22.0058 30.8769 35.7454 30.8769 39.159 29.9438C40.0915 29.6909 40.9417 29.1975 41.6248 28.5129C42.3079 27.8283 42.8001 26.9763 43.0524 26.0417C44.1416 19.954 44.4772 10.6966 43.0243 4.83514Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6045 22.0551L29.0024 15.4387L17.6045 8.82227V22.0551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_1325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYou);
export default __webpack_public_path__ + "static/media/ic_you.ffd13983582404b5132bf7608f4aada4.svg";
export { ForwardRef as ReactComponent };